import {EventEmitter} from 'eventemitter3'

export const filterDataTableEvent = new EventEmitter()

export const filterEventTypes = {
    pathway: 'PATHWAY',
    staticList: 'STATIC_LIST',
    hcp: 'HCP',
    sicknessLevel: 'SICKNESS_LEVEL',
    advanced: 'ADVANCED',
}

export function getFilterEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case filterEventTypes.pathway:
            return `PATHWAY_${tableType}`

        case filterEventTypes.staticList:
            return `STATIC_LIST_${tableType}`

        case filterEventTypes.hcp:
            return `HCP_${tableType}`

        case filterEventTypes.sicknessLevel:
            return `SICKNESS_LEVEL_${tableType}`

        case filterEventTypes.advanced:
            return `ADVANCED_${tableType}`

        default:
            return ''
    }
}

export function onFilterChangeListener(
    tableType,
    eventType = filterEventTypes.pathway,
    newFilterConfig = {},
) {
    if (!tableType) {
        return
    }

    filterDataTableEvent.emit(
        `${getFilterEventKey(tableType, eventType)}`,
        newFilterConfig,
    )
}

export function removeFilterChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    filterDataTableEvent.removeListener(
        `${getFilterEventKey(tableType, eventType)}`,
    )
}

export const filterExplainEvent = new EventEmitter()

export const filterExplainEventTypes = {
    PATHWAY_FILTER_EXPLAIN_CHANGE: 'PATHWAY_FILTER_EXPLAIN_CHANGE',
    STATIC_LIST_FILTER_EXPLAIN_CHANGE: 'STATIC_LIST_FILTER_EXPLAIN_CHANGE',
    SICKNESS_LEVEL_FILTER_EXPLAIN_CHANGE:
        'SICKNESS_LEVEL_FILTER_EXPLAIN_CHANGE',
    HCP_FILTER_EXPLAIN_CHANGE: 'HCP_FILTER_EXPLAIN_CHANGE',
    ADVANCED_FILTER_EXPLAIN_CHANGE: 'ADVANCED_FILTER_EXPLAIN_CHANGE',

    HAS_FILTER: 'HAS_FILTER',
    CLEAR_ALL_FILTER: 'CLEAR_ALL_FILTER',

    CLEAR_PATHWAY_FILTER: 'CLEAR_PATHWAY_FILTER',
    CLEAR_STATIC_LIST_FILTER: 'CLEAR_STATIC_LIST_FILTER',
    CLEAR_SICKNESS_LEVEL_FILTER: 'CLEAR_SICKNESS_LEVEL_FILTER',
    CLEAR_HCP_FILTER: 'CLEAR_HCP_FILTER',
    CLEAR_ADVANCED_FILTER: 'CLEAR_ADVANCED_FILTER',
}

export function getFilterExplainEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case filterExplainEventTypes.PATHWAY_FILTER_EXPLAIN_CHANGE:
            return `PATHWAY_FILTER_EXPLAIN_CHANGE_${tableType}`

        case filterExplainEventTypes.STATIC_LIST_FILTER_EXPLAIN_CHANGE:
            return `STATIC_LIST_FILTER_EXPLAIN_CHANGE_${tableType}`

        case filterExplainEventTypes.SICKNESS_LEVEL_FILTER_EXPLAIN_CHANGE:
            return `SICKNESS_LEVEL_FILTER_EXPLAIN_CHANGE_${tableType}`

        case filterExplainEventTypes.HCP_FILTER_EXPLAIN_CHANGE:
            return `HCP_FILTER_EXPLAIN_CHANGE_${tableType}`

        case filterExplainEventTypes.ADVANCED_FILTER_EXPLAIN_CHANGE:
            return `ADVANCED_FILTER_EXPLAIN_CHANGE_${tableType}`

        case filterExplainEventTypes.HAS_FILTER:
            return `HAS_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_ALL_FILTER:
            return `CLEAR_ALL_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_PATHWAY_FILTER:
            return `CLEAR_PATHWAY_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_STATIC_LIST_FILTER:
            return `CLEAR_STATIC_LIST_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_SICKNESS_LEVEL_FILTER:
            return `CLEAR_SICKNESS_LEVEL_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_HCP_FILTER:
            return `CLEAR_HCP_FILTER_${tableType}`

        case filterExplainEventTypes.CLEAR_ADVANCED_FILTER:
            return `CLEAR_ADVANCED_FILTER_${tableType}`

        default:
            return ''
    }
}

export function onFilterExplainChangeListener(
    tableType,
    eventType = filterExplainEventTypes.PATHWAY_FILTER_EXPLAIN_CHANGE,
    newFilterItems = [],
) {
    if (!tableType) {
        return
    }

    filterExplainEvent.emit(
        `${getFilterExplainEventKey(tableType, eventType)}`,
        newFilterItems,
    )
}

export function removeFilterExplainChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    filterExplainEvent.removeListener(
        `${getFilterExplainEventKey(tableType, eventType)}`,
    )
}

export function onFilterModeChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    filterExplainEvent.emit(
        `${getFilterExplainEventKey(tableType, eventType)}`,
        eventType,
    )
}

export function removeFilterModeChangeListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    filterExplainEvent.removeListener(
        `${getFilterExplainEventKey(tableType, eventType)}`,
    )
}
